import { render } from "./viewMode-grid.svg?vue&type=template&id=f7145446"
const script = {}
script.render = render

export default script